import React from 'react';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingServicedeskSelfServiceSetup: LazyComponent<
	typeof import('./SelfServiceSetupView.tsx').default
> = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-self-service-setup" */ './SelfServiceSetupView.tsx'
		).then((module) => module.default),
	),
);

const ServicedeskSelfServiceSetupComponent = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingServicedeskSelfServiceSetup}
		pageId="project-settings-self-service-setup"
		shouldShowSpinner
	/>
);

export default ServicedeskSelfServiceSetupComponent;
